var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83833 5.31422C13.1165 -1.5209 27.2231 0.823994 29.8212 12.3156C31.7365 20.7639 26.4736 27.915 21.8602 32.3387C20.2482 33.8912 18.0958 34.7588 15.8562 34.7588C13.6165 34.7588 11.4642 33.8912 9.85214 32.3387C5.25542 27.8984 -0.0241493 20.7473 1.90781 12.299",
    stroke: "white",
    strokeWidth: 2.99242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1539 15.859C21.1539 18.7763 18.7963 21.1509 15.862 21.1509C12.9278 21.1509 10.5702 18.7933 10.5702 15.859C10.5702 12.9247 12.9447 10.5671 15.862 10.5671C16.4387 10.5671 16.9984 10.6519 17.5073 10.8216",
    stroke: "white",
    strokeWidth: 2.99242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4ffed5a08e411b5510b2d2e8dc7cb687.svg";
export { ForwardRef as ReactComponent };